import React, { useContext, useState, useEffect } from "react";
import * as API from "../../api";
import { Popover, OverlayTrigger, ButtonToolbar } from "react-bootstrap";

const TextMacroComponent = ({ task, setTextFunction }) => {
  const [showContainer, setShowContainer] = useState(false);
  const [textMacros, setTextMacros] = useState([]);
  const [textMacroTags, setTextMacroTags] = useState([]);
  const [showTextMacroBody, setShowTextMacroBody] = useState(false);
  const [textMacroBodyToShow, setTextMacroBodyToShow] = useState(null);

  const fetchTextMacros = async () => {
    const response = await API.getTextMacros(
      task.patient ? task.patient.id : null,
      task.cpr ? task.cpr.id : null
    );
    if (response) {
      setShowContainer(true);
      setTextMacroTags(response.tags);
      setTextMacros(response.text_macros);
    }
  }

  return(<>
      <div id={"text-macros-container"} onClick={fetchTextMacros}>
        <span>
          <i className={'fa fa-align-justify blue-text'} ></i> Text Macros
        </span>
      </div>
      { showContainer && (
        <>
          <div id="text-macro-popover">
            <h3>
              <i className={'m-r-lg fa fa-align-justify'} ></i> Text Macros
              <i className={'fa fa-times red-text float-right'} id={'close-text-macros-container'} onClick={() => setShowContainer(false)}></i>
            </h3>
            { textMacros.map((el, id) => {
              return (
                <div key={id}
                  onClick={(e) => {
                    setTextFunction('body', el.body);
                    setShowContainer(false);
                  }}
                  className={'text-macro-container m-t-md'}
                >
                  <b
                    onMouseEnter={(e) => {
                      setTextMacroBodyToShow(id);
                      setShowTextMacroBody(true);
                    }}
                    onMouseLeave={(e) => {
                      setTextMacroBodyToShow(null);
                      setShowTextMacroBody(false);
                    }}
                  >{el.name}</b>
                  <br />
                  {
                    textMacroBodyToShow == id && setShowTextMacroBody && (
                      <div className={'text-macro-body-container'}>
                        {el.body}
                      </div>
                    )
                  }
                </div>
              );
            })}
          </div>
        </>)
      }
  </>);

};

export default TextMacroComponent;
